var $4316d19234208094$exports = {};
$4316d19234208094$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obligatorio)`
};


export {$4316d19234208094$exports as default};
//# sourceMappingURL=es-ES.mjs.map
